var render, staticRenderFns
import script from "./ShowRewardModal.vue?vue&type=script&lang=jsx&"
export * from "./ShowRewardModal.vue?vue&type=script&lang=jsx&"
import style0 from "./ShowRewardModal.vue?vue&type=style&index=0&id=5481fa6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5481fa6c",
  null
  
)

export default component.exports